import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../dashboard.css';

// Piezas compartidas con el estilo de la sala de control (dashboard): formato de números y
// fechas, semáforo del cumplimiento de horas y la ventana modal. Las usan el dashboard y otras
// pantallas que quieren verse igual (p. ej. Horas autorizadas → Ver semanas).

export const nf = (valor, decimales = 0) =>
  Number(valor || 0).toLocaleString('es-CO', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  });

// Semáforo del cumplimiento de horas (mismos umbrales que el backend).
export const ESTADO_HORAS = {
  sobrecosto_critico: { sev: 'var(--critical)', ink: 'var(--critical-ink)', texto: 'Sobrecosto' },
  sobrecosto: { sev: 'var(--serious)', ink: 'var(--warn-ink)', texto: 'Sobrecosto' },
  critico: { sev: 'var(--critical)', ink: 'var(--critical-ink)', texto: 'Crítico' },
  alerta: { sev: 'var(--warning)', ink: 'var(--warn-ink)', texto: 'En alerta' },
  ok: { sev: 'var(--good)', ink: 'var(--good-ink)', texto: 'En meta' },
  sin_datos: { sev: 'var(--rule-strong)', ink: 'var(--ink-3)', texto: 'Sin plan' },
};

export const estadoHoras = (pct) => {
  if (pct == null) return 'sin_datos';
  if (pct > 110) return 'sobrecosto_critico';
  if (pct > 100) return 'sobrecosto';
  if (pct >= 95) return 'ok';
  if (pct >= 85) return 'alerta';
  return 'critico';
};

export const fechaCorta = (yyyyMMdd) => {
  if (!yyyyMMdd) return '—';
  const [y, m, d] = yyyyMMdd.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('es-CO', { day: 'numeric', month: 'short' });
};

// Ventana modal con el estilo de la sala de control. Se cierra con Esc o
// haciendo clic fuera.
export const Modal = ({ titulo, subtitulo, onCerrar, acciones, children, ancho = 980 }) => {
  useEffect(() => {
    const alPresionar = (e) => e.key === 'Escape' && onCerrar();
    window.addEventListener('keydown', alPresionar);
    const overflowPrevio = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', alPresionar);
      document.body.style.overflow = overflowPrevio;
    };
  }, [onCerrar]);

  // Portal al body: un ancestro con transform (animaciones del layout) rompería
  // el position: fixed. El envoltorio conserva los tokens de color del tablero.
  return createPortal(
    <div className="sala-control" style={{ background: 'transparent', minHeight: 0 }}>
    <div className="modal-fondo" onClick={onCerrar} role="presentation">
      <div
        className="modal-caja"
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        style={{ maxWidth: ancho }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-cab">
          <div style={{ minWidth: 0 }}>
            <h3>{titulo}</h3>
            {subtitulo && <div className="card-sub" style={{ margin: '2px 0 0' }}>{subtitulo}</div>}
          </div>
          <span className="spacer" />
          {acciones}
          <button type="button" className="ctl" onClick={onCerrar} aria-label="Cerrar">
            ✕
          </button>
        </div>
        <div className="modal-cuerpo">{children}</div>
      </div>
    </div>
    </div>,
    document.body,
  );
};
